<template><div><h1>VUX V2.5.11 released</h1>
<h2><a href="/en/components/datetime.html">Datetime</a></h2>
<ul><li>[fix] fix :show.syc="false" do no work #1918</li>
<li>[fix] fix prop:compute-hours-function not working when month is changed</li>
</ul>
<h2><a href="/en/components/inline-calendar.html">InlineCalendar</a></h2>
<ul><li>[feature] support method:getDates</li>
<li>[feature] support less variable @calendar-bg-color</li>
</ul>
<h2><a href="/en/components/popup.html">Popup</a></h2>
<ul><li>[fix] add vux-modal-open only when global config:$layout is VIEW_BOX #1893</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.5.11 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.5.11-122.vue?18abde5a